// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productDetailsImageCarouselStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel";
import { IconWrapper } from "@insite/mobius/Icon";
import { color, hideElementOnPrint, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

const overrideStyles = (isSelected?: boolean) => ({
    css: css`
        max-width: 52px;
        max-height: 52px;
        box-sizing: border-box;
        border: 1px solid transparent;
        border-radius: 1px;
        border-color: ${isSelected && BLUEPRINT_NAME === "turnerBlueprint"
            ? css`
                  ${color("common.ui11")}
              `
            : isSelected && BLUEPRINT_NAME !== "turnerBlueprint"
            ? css`
                  ${color("common.ui4")}
              `
            : "transparent"};

        overflow: hidden;
        img {
            max-width: 50px;
            max-height: 50px;
            width: 50px;
            height: 50px;
            padding: 0;
        }
    `,
});

productDetailsImageCarouselStyles.imageCarousel = {
    carouselWrapper: {
        css: css`
            ${hideElementOnPrint}
            max-width: 641px;
            margin: 0 auto;
            ${xScreen("lt", "lg")} {
                max-width: 543px;
            }

            ${xScreen("lte", "md")} {
                max-width: 358px;
            }

            ${xScreen("lte", 767)} {
                max-width: 100%;
            }
            &:has(.arrow-button:not(.swiper-button-disabled)) {
                .swiper {
                    padding: 0 24px;
                }
                & .arrow-button.swiper-button-disabled {
                    opacity: 0.33;
                    background: white;
                    display: flex !important;
                    padding: 0;
                    width: 24px;
                    text-align: center;
                }
            }
        `,
    },
    carousel: {
        container: {
            css: css`
                margin-top: 15px;

                &&& {
                    .arrow-button {
                        background: white;
                        width: 24px;
                        text-align: center;
                        ${IconWrapper}, svg {
                            color: ${color("common.ui4")};
                        }
                        &:not(.swiper-button-disabled):hover {
                            ${IconWrapper}, svg {
                                color: ${color("common.ui9")};
                            }
                        }

                        &.xng-carousel-prev {
                            justify-content: flex-start;
                        }

                        &.xng-carousel-next {
                            justify-content: flex-end;
                        }
                    }
                }
            `,
        },
    },
    image: overrideStyles(),
    selectedImage: overrideStyles(true),
    carouselSlideInner: {
        css: css`
            padding: 0;
        `,
    },
} as any;
